import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=a17df260&"
import script from "./Signup.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Signup.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Signup.vue?vue&type=style&index=0&id=a17df260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports